module.exports = __webpack_public_path__ + "img/homepage-background-mobile.ea2cddd.png";